import React, { useState } from "react";
import { connect, useDispatch } from "react-redux";

import BaseCreationStepContentByConfig from "components/base/BaseCreationStepContentByConfig";
import { SEGMENT_CREATION_STEP_ONE_CONFIG } from "./SegmentCreationConfig";
import { SaveAndBackWithOutTempButtons } from "components/base/BottomStepComponent";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import { useFormContext } from "react-hook-form";
import BasePrompt from "components/base/prompt/BasePrompt";
import { SEGMENT_TYPE, STATIC_SEGMENT_CUSTOMER_SOURCE } from "config/CustomEnums";
import { createAction } from "utils";
import { useParams } from "react-router-dom/cjs/react-router-dom";

const CreateSegmentStepOne = ({
  isLoading,
}) => {
  const params = useParams();
  const isEdit = !!(params.id)
  const { getValues, trigger, watch } = useFormContext();
  const segmentType = watch("segmentType")
  const staticSegmentCustomerSource = watch("staticSegmentCustomerSource")
  const [showPrompt, setShowPrompt] = useState(false)

  const history = useHistory();
  const dispatch = useDispatch();

  const confirmAction = async () => {
    const result = await trigger(undefined, { shouldFocus: true });
    if (result) {
      dispatch(createAction("segments/createOrUpdateSegment")({
        data: getValues()
      }))
    }
  }

  return (
    <>
      <BaseCreationStepContentByConfig
        isLoading={isLoading}
        configuration={SEGMENT_CREATION_STEP_ONE_CONFIG}
        hidePreview={true}
      />
      <BasePrompt
        show={showPrompt}
        closeAction={()=> setShowPrompt(false)}
        rightButton={{
          text: 'Confirm',
          action: confirmAction,
        }}
        leftButton={{
          text: 'Cancel',
          action: () => setShowPrompt(false),
        }}
        title={'Confirm to save?'}
        description={'Confirm to update the customer list with the latest conditions.'}
        customClass={'container'}
      />
      <SaveAndBackWithOutTempButtons
        saveText={'Save'}
        saveAction={() => {
          if (
            isEdit &&
            segmentType === SEGMENT_TYPE.STATIC
            && staticSegmentCustomerSource === STATIC_SEGMENT_CUSTOMER_SOURCE.CONDITION
          ) {
            setShowPrompt(true)
            return
          }
          confirmAction()
        }}
        backAction={() => history.goBack()}
      />
    </>
  )
}

const mapPropsToState = (state) => ({
});

export default connect(mapPropsToState)(CreateSegmentStepOne);